<template>
    <main-layout>
        <div class="container has-text-white">
            <H1 class="pageTitle">PAYMENT</H1>
          

           <div class="limitWidth botMargin top40">
                <div class="is-size-4">
                    Your Order Total: ${{az.formatCurrency(info.cartTotal)}}
                </div>
                <div id="billingInfo">
                    <div class="has-text-weight-bold top20">
                        Billing Information:
                    </div>
                    <div class="top20">
                        <div id="ccDiv" class="has-background-petBlue has-text-white">
                            Credit Card ending in  *<span class="has-text-weight-bold">{{info.last4}}</span>
                            <button class="button is-small is-pulled-right top-2" @click="update">UPDATE</button>
                        </div>
                        <div class="left10">
                            <span>{{info.nameOnCard}}</span><br>
                            <span>{{info.address1}}</span><br>
                            <span v-show="info.address2">{{info.address2}}</span><br v-show="info.address2">
                            <span>{{info.city}}</span>, <span>{{info.state}}</span>  <span>{{info.zip}}</span><br>
                            
                           
                            <span>{{info.country | countryFromCode}}</span><br>
                        </div>
                  
                        <button id="submitPmtBt" class="button is-warning top20" @click="submit">SUBMIT PAYMENT</button>
                        <button v-if="isAdmin" id="submitFreeBt" class="button is-warning top20" @click="submitFree">GET FOR FREE</button>
                    </div>
                </div>
           </div>


        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import countries from '../STATIC/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';

export default {
  data: function(){
      return{
          info: {},
          countries,
          payload: {},
          az: az,
          inited: false,
          stripe: {},
          isAdmin: false
      }
  },
  filters: {
    countryFromCode: function (value) {
        if (!value) return '';
        value = value.toString();
        for(var i=0; i < countries.length; i++){
            if(value == countries[i].code){
                return countries[i].name;
            }
        }
        return ''
    }
  }, 
  components: {
    MainLayout
  },
  mounted: function(){
        const self = this
        az.addRemSpinner(true, 'id', 'billingInfo');
        self.worked = function (data) {
            az.addRemSpinner(false, 'id', 'billingInfo');
            if(data.response == false || data.last4 == undefined){
                self.update(); //navigate to update page
            } else {
              self.payload = data;
              self.info = data;
            }
        }
        self.noWorked = function () {
            az.addRemSpinner(false, 'id', 'billingInfo');
            self.$root.showModalOK({message: 'There was en error loading the information. Please try again.'})
        }

        function configStripe() {
            self.stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY)
        }

        function init(){
            self.inited = true
            var cartID = az.getCookie('SlinkCartID');
            self.$root.apiClient.get('api/account/pmtMech/true', {}, self.worked, self.noWorked, null, {'cart-user-id': cartID});
            self.$root.loadScript('https://js.stripe.com/v3/', configStripe)
            self.checkAccountType();
        }

        if(self.$root.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });
       
  },
  methods:{
      update: function(){
          this.$router.push({name: 'pmtSrc', params:{goAfter: '/pmt', payload: this.payload}});
      },
      submit: function(){
           var self = this;
           az.addRemSpinner(true, 'id', 'submitPmtBt');

           function worked(data){
               az.addRemSpinner(false, 'id', 'submitPmtBt');
               if(data.statusCode == 666){
                   if(data.response == 'customer_max_subscriptions'){
                       self.$root.showModalOK({message: 'You have reached the maximum allowed limit of 500 subscriptions.'})
                   } else if(data.response == 'card_declined'){
                       self.$root.showModalOK({message: 'Oops! Your credit card was declined. Please check the information submitted.'})
                   } else if(data.response == 'card_expired'){
                       self.$root.showModalOK({message: 'Oops! Your credit card has expired. Please submit a valid card.'})
                   } else {
                       self.$root.showModalOK({message: 'There was en error processing the information.'})
                   }
                   return
               }

               var declined3d =  false
               const delay = ms => new Promise(res => setTimeout(res, ms));
               if(data.pi){

                   async function poll(){
                       async function w(d){
                            
                           if(d.status == 'succeeded'){
                               self.$root.hideModalFullSpinner()
                               self.$root.cartContents = [];
                               document.cookie = "SlinkCartID=''"
                               az.deleteCookie('SlinkCartID');
                               let od = d.orderId.split('order-')[1]
                               self.$router.push({name: 'orderdetails', params: {id: od, serverObj: undefined}, query:{id: od}});
                              
                           } else {
                               await delay(2000)
                               poll()
                           }
                       }

                       function n(){
                           return false
                       }
                       self.$root.apiClient.get('api/cart/status3d/' + data.pi, {}, w, n)
                   }

                   self.$root.showModalFullSpinner()
                   self.stripe.confirmCardPayment(data.cs)
                    .then(async function(result) {
                       
                        if(result.paymentIntent && result.paymentIntent.status == 'succeeded'){
                           poll()

                        } else {
                            self.$root.hideModalFullSpinner()
                            self.$root.showModalOK({message: 'We are unable to authenticate your payment method. Please choose a different payment method and try again.'})
                            declined3d = true
                        }
                    })
                    .catch(function(e){
                        
                    });

               } else {
                   if(!declined3d){
                        self.$root.cartContents = [];
                        document.cookie = "SlinkCartID=''"
                        az.deleteCookie('SlinkCartID');
                        self.$router.push({name: 'orderdetails', params: {id: data.orderId, serverObj: data}, query:{id: data.orderId}});
                   }
               }
               
              
           }
           function noWorked(err){
               az.addRemSpinner(false, 'id', 'submitPmtBt');

           }

           var cartID = az.getCookie('SlinkCartID');
           self.$root.apiClient.post('api/cart/process', {bypass: false}, worked, noWorked, null, {'cart-user-id': cartID});
      },
      submitFree: function(){
           var self = this;
           az.addRemSpinner(true, 'id', 'submitFreeBt');

           function worked(data){
               az.addRemSpinner(false, 'id', 'submitFreeBt');
               self.$root.cartContents = [];
               document.cookie = "SlinkCartID=''"
               az.deleteCookie('SlinkCartID');
               self.$router.push({name: 'orderdetails', params: {id: data.orderId, serverObj: data}, query:{id: data.orderId}});
           }
           function noWorked(err){
               az.addRemSpinner(false, 'id', 'submitFreeBt');
           }
           var cartID = az.getCookie('SlinkCartID');
           self.$root.apiClient.post('api/cart/processfree', {bypass: false}, worked, noWorked, null, {'cart-user-id': cartID});
      },
      checkAccountType: function(){
           var self = this;
           if (!self.$root.accountType) {
               self.$root.apiClient.get('api/account', {},
               (data) => {
                   let accountType = data.Item.accountType;
                   if (accountType === 'admin') {
                       self.isAdmin = true;
                       self.$root.accountType = 'admin';
                   }
               },
               () => {
                   return false;
               });
           } else if (self.$root.accountType === 'admin') {
               self.isAdmin = true;
           }
      }
  }
}
</script>

<style scoped>
    #ccDiv{
        padding: 8px;
        border-radius: 5px;
    }

    .botMargin{
        margin-bottom: 60px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Pmt.vue